import { useQuery } from "@tanstack/react-query";
import getPlans from "services/getPlans";

export const usePlans = () => {
  const { data, isLoading } = useQuery(["getPlans"], getPlans, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
  return { plans: data, isLoading };
};
